<div>
  <app-nav-bar>
    <main class="container-main">
      <div class="row back-button">
        <p (click)="goBack()" class="back-title tappable">Voltar</p>
      </div>
      <div class="d-flex align-items-center row-header-send">
        <ng-container>
          <div>
            <span class="screen-title">Histórico de ordens</span>
          </div>
        </ng-container>
        <!--   <ng-container *ngIf="rType == '1'">
          <div>
            <span class="screen-title">Histórico de ordens de envio</span>
          </div>
        </ng-container> -->
 
        <div class="d-flex gap-3 orders-history-btns">
          <button
            type="button"
            class="btn-footer btn btn-outline-dark"
            (click)="openExchangeDocumentsCheckModal()"
          >
            Consultar comprovantes
          </button>

          <button
            type="button"
            class="btn-footer btn-exchange btn btn-dark-primary-blue"
            (click)="openExchangeOrdersComponentModal(this.rType)"
          >
            Consultar ordens no exchange
          </button>
        </div>
      </div>

      <ng-container>
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          animationDuration="0ms"
          (selectedTabChange)="changeTabStatus($event)"
        >
          <mat-tab label="Todas as ordens"></mat-tab>
          <mat-tab label="Em andamento"></mat-tab>
          <mat-tab label="Finalizadas"> </mat-tab>
        </mat-tab-group>
      </ng-container>

      <div class="card-filters">
        <div class="header-filter">
          <h5>Filtros</h5>
        </div>

        <form [formGroup]="filterForm" (ngSubmit)="onFilter()">
          <div class="content-filter">
            <div class="row">
              <div class="col-3">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Nº do boleto</mat-label>
                  <input matInput type="text" formControlName="slipCode" />
                </mat-form-field>
              </div>
             
              <div class="col-3">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Moeda</mat-label>
                  <mat-select formControlName="currency">
                    <mat-option [value]="null">Todas as moedas</mat-option>
                    <mat-option *ngFor="let moeda of moedas" [value]="moeda">
                      <img [src]="moeda.image" width="15px" height="15px" />
                      <span class="ml-2">{{ moeda.description }}</span>
                    </mat-option>
                    <mat-select-trigger>
                      <span class="d-flex align-items-center">
                        <ng-container
                          *ngIf="filterFormControls.currency.value; else noIcon"
                        >
                          <mat-icon
                            [svgIcon]="filterFormControls.currency.value?.icon"
                            class="mr-2"
                          ></mat-icon>
                        </ng-container>
                        <ng-template #noIcon></ng-template>
                        <span>
                          {{
                            filterFormControls.currency.value?.description ||
                              "Todas as moedas"
                          }}
                        </span>
                      </span>
                    </mat-select-trigger>
                  </mat-select>
                </mat-form-field>
              </div>
               <div class="col-3">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Origem da moeda</mat-label>
                  <mat-select formControlName="bankCurrencyTreasury">
                    <mat-option [value]="''">Todas</mat-option>
                    <mat-option
                      *ngFor="let bank of demeBanks$ | async"
                      [value]="bank"
                    >
                      {{ bank }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-3">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Valor</mat-label>
                  <input
                    matInput
                    formControlName="value"
                    type="text"
                    currencyMask
                    [options]="{
                      prefix: currency + ' ',
                      thousands: '.',
                      decimal: ','
                    }"
                  />
                </mat-form-field>
              </div>

            <div class="col-3">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Tipo de ordem</mat-label>
                  <mat-select formControlName="remmitanceType">
                    <mat-option [value]="null">Todos</mat-option>
                    <mat-option
                      *ngFor="let type of remmitanceTypeOptions"
                      [value]="type.value"
                    >
                      {{ type.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-3">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Data de criação</mat-label>
                  <input
                    matInput
                    [matDatepicker]="createdDatePicker"
                    formControlName="createdDate"
                  />
                  <mat-datepicker-toggle
                    matPrefix
                    [for]="createdDatePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #createdDatePicker></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="col-3">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Origem</mat-label>
                  <mat-select formControlName="orderSource">
                    <mat-option [value]="null">Todas as origens</mat-option>
                    <mat-option
                      *ngFor="let source of orderSourceOptions"
                      [value]="source.value"
                    >
                      {{ source.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-3">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Tipo de Pessoa</mat-label>
                  <mat-select formControlName="personType">
                    <mat-option value="Pj">PJ - Pessoa Jurídica</mat-option>
                    <mat-option value="Pf">PF - Pessoa Física</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-3">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Status</mat-label>
                  <mat-select formControlName="statusFlow">
                    <mat-option [value]="null">Todos os status</mat-option>
                    <mat-option
                      *ngFor="let status of statusFlowOptions"
                      [value]="status.value"
                    >
                      {{ status.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-3">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Swift</mat-label>
                  <mat-select formControlName="withSwift">
                    <mat-option [value]="''">Todas</mat-option>
                    <mat-option [value]="'true'">Ordens com Swift</mat-option>
                    <mat-option [value]="'false'">Ordens sem Swift</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-3">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Tipo de pendência</mat-label>
                  <mat-select formControlName="pendencyType">
                    <mat-option
                      *ngFor="let option of pendencyTypeOptions"
                      [value]="option.value"
                    >
                      {{ option.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="buttons-filter">
              <button
                type="button"
                [style.width]="'134px'"
                class="btn-outline-dark btn"
                (click)="onClearFilters()"
              >
                Limpar
              </button>

              <button
                [style.width]="'auto'"
                class="btn btn-dark-primary-blue"
                type="submit"
              >
                Aplicar Filtros
              </button>
            </div>
          </div>
        </form>
      </div>

      <div
        *ngIf="loading"
        class="accordion-item painel painel-accordion error-orders"
      >
        <div class="img-error-orders">
          <span class="spinner-border text-primary" *ngIf="loading"></span>
        </div>
      </div>

      <ng-container *ngIf="haveOrders">
        <div class="box-order">
          <div class="padding-bottom-32 padding-top-10 header-box">
            <span class="mb-0"> Histórico com todas as ordens criadas </span>
            <div class="search-container">
              <input
                type="text"
                class="search-input"
                [formControl]="searchControl"
                placeholder="Pesquisar pelo nº da ordem, cliente, cnpj... "
                (keyup.enter)="onFilter()"
              />
              <img
                src="assets/image/search.svg"
                class="search-icon"
                (click)="onFilter()"
              />
            </div>
          </div>

          <div class="padding-content">
            <ng-container *ngIf="!isMobile">
              <app-table-history
                *ngIf="showTables"
                [displayedColumns]="tableDisplayedColumns"
                [data]="orders"
                [pageNumber]="pageNumber"
                [pageSize]="pageSize"
                [totalElements]="totalElements"
                (pageChange)="updatePageData($event)"
              ></app-table-history>
            </ng-container>

            <ng-container *ngIf="isMobile">
              <app-table-history
                *ngIf="showTables"
                [displayedColumns]="tableDisplayedColumns"
                [data]="orders"
                [pageNumber]="pageNumber"
                [pageSize]="pageSize"
                [totalElements]="totalElements"
                (pageChange)="updatePageData($event)"
              ></app-table-history>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <div
        *ngIf="!haveOrders && !showOrderError"
        class="accordion-item painel painel-accordion no-orders"
      >
        <div class="img-no-orders">
          <img width="240" height="160" src="assets/image/no-order-icon.svg" />
        </div>

        <p id="txt-create-order">Não há ordens para o filtro selecionado.</p>
      </div>

      <div
        *ngIf="showOrderError"
        class="accordion-item painel painel-accordion error-orders"
      >
        <div class="img-error-orders">
          <img
            width="258"
            height="160"
            src="assets/image/error-order-icon.svg"
          />
        </div>

        <p id="txt-error-orders-register">Infelizmente encontramos um erro!</p>
        <p id="txt-error-order">
          Você pode aguardar uns instantes e tentar recarregar a <br />página
          mais uma vez.
        </p>

        <div class="btn-send-content">
          <button
            (click)="reloadPage()"
            class="btn btn-block mt-0 ml-3 btn-dark-primary-blue"
            type="button"
          >
            Tentar Novamente
          </button>
        </div>
      </div>
    </main>
  </app-nav-bar>
</div>
